import dynamic from 'next/dynamic';
import { StickyBarProps } from './StickyBar.types';

export const StickyBarMGP = dynamic<StickyBarProps>(() => import('./StickyBar').then(module => module.StickyBar));
